const CardList = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/cardMember/List.vue')
const CardDetail = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/cardMember/Detail.vue')
const LessonList = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/cardMember/LessonList.vue')
const CourseList = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/cardMember/CourseList.vue')
const SpecialList = () =>
  import(
    /* webpackChunkName: "camp" */ '../../pages/cardMember/SpecialList.vue'
  )
const CampList = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/cardMember/CampList.vue')
export default [
  {
    path: '/cardMember/list',
    meta: { title: '权益卡列表' },
    component: CardList,
  },
  {
    path: '/cardMember/detail',
    meta: { title: '权益卡详情' },
    component: CardDetail,
  },
  {
    path: '/cardMember/lesson',
    meta: { title: '权益卡课节列表' },
    component: LessonList,
  },
  {
    path: '/cardMember/course',
    meta: { title: '权益卡课程列表' },
    component: CourseList,
  },
  {
    path: '/cardMember/special',
    meta: { title: '权益卡专栏列表' },
    component: SpecialList,
  },
  {
    path: '/cardMember/camp',
    meta: { title: '训练营列表' },
    component: CampList,
  },
]
